{
  "notifications": {
    "errors": {
      "validation": "Corrija los errores y envíe el formulario de nuevo",
      "invalid_website": "debe ser un sitio web válido",
      "password_change": "El cambio de contraseña no fue exitoso",
      "invalid_url": "es una URL no válida",
      "unknown": "Se produjo un error desconocido",
      "unknown_with_contact": "Algo salió mal, inténtelo de nuevo o póngase en contacto con el soporte",
      "document_not_found": "No se encontró el documento",
      "thiamis_location": "La ubicación no se reportó durante las últimas 2 horas, vaya a la configuración de Thiamis y cambielo manualmente en caso de que haya algún error",
      "permission_error": "Error de autorización",
      "insecure_operation_error": "Operación insegura",
      "access_denied": "Acceso denegado",
      "access_context_error": "Error en el contexto del acceso: %{error_detail}",
      "user_not_member_of_organization": "el usuario no es miembro de la organización",
      "no_org_left_to_be_assigned": "no queda ninguna organización por asignar",
      "no_project_left_to_be_assigned": "no project left to be assigned",
      "could_not_create_account": "No pudo crearse la cuenta de usuario. Corrija los errores.",
      "invitation_email_not_the_same": "La dirección de correo electrónico para la cuenta del usuario debe ser la misma que para la invitación",
      "invitation_already_accepted": "La invitación ya fue aceptada.",
      "email_password_invalid": "El correo electrónico o la contraseña eran incorrectos",
      "role_already_exists": "El usuario ya tiene una función similar para la misma organización.",
      "too_many_selected_items": "Demasiados elementos seleccionados",
      "is_invalid": "No es válido",
      "owner_can_invite_managers": "Solo el propietario de la organización puede invitar a los administradores",
      "org_has_owner": "La organización ya tiene un propietario",
      "user_registered": "El usuario ya está registrado",
      "user_not_registered": "El usuario no está registrado",
      "inivitation_exists": "La invitación ya existe",
      "user_role_exists": "El usuario ya tiene esta función",
      "record_deleted": "Error al borrar un registro",
      "server_error": "No pudo realizarse su solicitud, inténtelo de nuevo más tarde",
      "page_not_found": "¡Vaya! No se encontró la página solicitada",
      "system_error": "Algo salió mal, inténtelo de nuevo más tarde. Investigaremos el problema",
      "auth_error": "Se produjo un error de autorización. Inténtelo de nuevo más tarde o póngase en contacto con el soporte",
      "environet_bootstrap_error": "Environet no pudo iniciar. Inténtelo de nuevo más tarde o póngase en contacto con el soporte",
      "clusternet_bootstrap_error": "Clusternet no pudo iniciar. Inténtelo de nuevo más tarde o póngase en contacto con el soporte",
      "signup_form_error": "Corrija los errores",
      "invalid_user_invitation": "La invitación del usuario no es válida",
      "destroy_missing_message_ids": "Identificadores de mensajes que faltan por borrar.",
      "address_not_found": "No se encontró la dirección",
      "google_maps_no_geo": "El punto de retorno para la función Autocompletar no contiene geometría",
      "no_data_points_selected": "seleccione al menos uno",
      "passwords_must_match": "Las contraseñas deben coincidir",
      "invalid_pdf_response": "No puede crearse un PDF, inténtelo de nuevo más tarde",
      "invalid_file_download_response": "No se pudo descargar el archivo, inténtelo de nuevo más tarde",
      "users_without_phone_number": "Los siguientes usuarios no tienen número de teléfono, por favor configúrelo en el perfil de usuario para recibir SMS:\n%{emails}"
    },
    "info": {
      "creating_pdf_report": "Creando informes en PDF, espere...",
      "downloading_pdf": "Descargando informes en PDF, espere...",
      "new_release_available": "Hay una nueva versión disponible. Actualice la página para obtenerla; esto ocurrirá automáticamente la próxima vez que navegue.",
      "token_refresh_message": "Actualizando. Espere..",
      "selected_params_limit": "Solo puede ver 3 puntos de datos a la vez",
      "no_data_to_analyze": "No hay datos para analizar en el período de tiempo especificado.",
      "downloading_file_with_format": "Descargando %{format}, por favor espere...",
      "downloading_file": "Descargando archivo, por favor espere..."
    },
    "success": {
      "logged_out": "Usted cerró sesión exitosamente",
      "password_created": "Su contraseña se restableció exitosamente",
      "record_deleted": "El registro se eliminó exitosamente",
      "api_token_deleted": "Clave de API eliminada exitosamente",
      "new_updates": "Hay nuevas actualizaciones disponibles, <a class=\"load-new-updates\">haga clic aquí para cargar</a>",
      "roles_updated": "Su información de acceso ha sido actualizada",
      "thiamis_reset": "Thiamis se ha reiniciado exitosamente",
      "locale_changed": "El idioma de visualización cambiará la próxima vez que inicie sesión",
      "remove_stat_message": "El parámetro estadístico ha sido eliminado exitosamente",
      "remove_calibration_message": "El parámetro de calibración ha sido eliminado exitosamente",
      "add_calibration_message": "El parámetro de calibración ha sido añadido exitosamente",
      "add_stat_message": "El parámetro estadístico ha sido añadido exitosamente",
      "user_deleted": "El usuario %{email} ha sido eliminado exitosamente",
      "widgets_add_to_dashboard": "Los widgets han sido añadidos al panel",
      "pdf_report_ready": "El informe PDF está listo para descargar, haga clic en el enlace a continuación <a target=\"_blank\" href=\"%{url}\">%{filename}</a>",
      "endpoint_updated": "El punto final se actualizó exitosamente",
      "action_performed": "La acción '%{action}' se envió exitosamente",
      "node_public_link_updated": "Panel público actualizado exitosamente",
      "node_public_link_created": "Enlace público creado exitosamente",
      "node_public_link_deleted": "Enlace público eliminado exitosamente",
      "partnership_invitation_deleted": "La invitación de asociación ha sido eliminada exitosamente",
      "partnership_deleted": "La asociación ha sido eliminada exitosamente",
      "organization_locked": "La organización ha sido bloqueada exitosamente",
      "organization_unlocked": "La organización ha sido desbloqueada exitosamente",
      "organization_deleted": "La organización ha sido eliminada exitosamente",
      "firmware_rolledout_serials": "La solicitud de despliegue de firmware [%{version}] ha sido enviada a %{serials}",
      "firmware_rolledout_channel": "La solicitud de despliegue de firmware [%{version}] ha sido enviada a %{channel}",
      "calibration_run": "La solicitud de calibración ha sido enviada. Calibrados: %{calibrated}. Faltantes: %{missing}",
      "device_blink_led": "La solicitud de identificación del dispositivo con LED ha sido enviada.",
      "calibration_device_reset": "La solicitud de reinicio del dispositivo ha sido enviada a %{serials}",
      "calibration_device_transfer": "La solicitud de transferencia del dispositivo ha sido enviada a %{serials}",
      "report_deleted": "El panel ha sido eliminado exitosamente",
      "report_shared": "El panel ha sido compartido exitosamente",
      "wifi_scan": "La solicitud de escaneo de redes WiFi ha sido enviada, debería tomar hasta 2 minutos para actualizar la lista",
      "chat_assistant_deleted": "Asistente de IA Noesis eliminado exitosamente",
      "forms": {
        "voc_calibration": "La solicitud de calibración se ha enviado exitosamente, debería tomar entre 40-90 segundos para aplicarse",
        "files": "El archivo Thiamis ha sido actualizado",
        "profile": "La información de su perfil ha sido actualizada",
        "api_token": "Clave de API creada exitosamente",
        "support": "Su solicitud de soporte ha sido enviada exitosamente",
        "users": "La información del usuario ha sido guardada",
        "organizations": "La información de la organización ha sido guardada",
        "alerts": "La información de la alerta ha sido guardada",
        "formation_requests": "Su solicitud de organización ha sido enviada exitosamente",
        "user_invitations": "La invitación del usuario ha sido enviada exitosamente",
        "user_invitation_permission_update": "El usuario fue invitado a la nueva organización exitosamente",
        "signup_in_progress": "La solicitud de registro ha sido enviada, esperando respuesta...",
        "partnership_created": "La asociación ha sido creada",
        "partnership_removed": "La asociación ha sido eliminada",
        "partnership_invitations": "La invitación de asociación ha sido enviada exitosamente",
        "user_invitation_deleted": "La invitación del usuario ha sido eliminada",
        "delete_report": "El informe ha sido eliminado",
        "user_invitation_accepted": "La invitación del usuario ha sido aceptada",
        "user_invitation_declined": "La invitación del usuario ha sido rechazada",
        "create_certificate": "El certificado ha sido creado exitosamente",
        "update_certificate": "El certificado ha sido actualizado exitosamente",
        "delete_certificate": "El certificado ha sido eliminado exitosamente",
        "create_alert": "La alerta ha sido creada exitosamente",
        "update_alert": "La alerta ha sido actualizada exitosamente",
        "delete_alert": "La alerta ha sido eliminada exitosamente",
        "create_organization": "La organización ha sido creada exitosamente",
        "update_organization": "La organización ha sido actualizada exitosamente",
        "delete_organization": "La organización ha sido eliminada exitosamente",
        "delete_user": "El usuario ha sido eliminado exitosamente",
        "create_partnership": "La asociación ha sido creada exitosamente",
        "delete_partnership": "La asociación ha sido eliminada exitosamente",
        "create_node": "La configuración del dispositivo ha sido creada exitosamente",
        "update_node": "El dispositivo ha sido actualizado exitosamente",
        "update_sensor": "El sensor ha sido actualizado exitosamente",
        "delete_node": "El dispositivo ha sido reiniciado exitosamente",
        "create_webhook": "El webhook ha sido creado exitosamente",
        "create_dashboard": "El panel ha sido creado exitosamente",
        "update_dashboard": "El panel ha sido actualizado exitosamente",
        "create_report": "El informe ha sido creado exitosamente",
        "update_report": "El informe ha sido actualizado exitosamente",
        "clone_report": "El informe ha sido clonado con éxito"
      }
    },
    "warnings": {
      "important": "¡Advertencia importante!",
      "partnership_invitation_accept_no_organization": "¡Por favor, cree una Organización primero!",
      "partnership_invitation_accept_all_organizations_selected": "Por favor, elija qué organización debe asociarse",
      "are_you_sure": "¿Está seguro?",
      "no_phone": "Por favor, configure su número de teléfono en su perfil para recibir notificaciones SMS cuando se active una alerta",
      "ie11_deprecated": "Su navegador web (Internet Explorer 11) está desactualizado, por favor actualícelo o cambie a otro.",
      "fill_profile": "Por favor, proporcione la información requerida para completar su perfil",
      "account_past_due": "Su cuenta está <b>VENCIDA</b>! Para evitar interrupciones del servicio, póngase en contacto con <em>accounting@netronixgroup.com</em>"
    }
  }
}